import * as Sentry from '@sentry/vue';

function setUserContext(profile) {
  Sentry.setUser({
    personId: profile.personId,
    name: profile.name,
    email: profile.email,
  });
}

function initSentry(app, store, url) {
  Sentry.init({
    app,
    dsn: url,
    environment: import.meta.env.VITE_ENV,
    integrations: [],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  if (store.getters['session/isLoggedIn']) {
    setUserContext(store.state.session.profile);
  }

  store.subscribe((mutation) => {
    switch (mutation.type) { // eslint-disable-line
      case 'session/updateProfile':
        setUserContext(store.state.session.profile);
        break;
    }
  });
}

export default function configureErrorHandling(app, store) {
  if (import.meta.env.VITE_SENTRY_URL) {
    initSentry(app, store, import.meta.env.VITE_SENTRY_URL);
  }

  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
    store.dispatch('app/unhandledError', event.reason);
  });
}
